import {Person, PersonRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {Box, Stack, TableCell, Typography} from "@mui/material";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import {useApiManager} from "../../../../components/utils/api";
import React, {useEffect, useState} from "react";
import {fileLocalSave} from "../../../../components/form/form_inputs/form_file";
import {PersonAvatar, SoftChip} from "../../../../components/kit";
import {personName} from "./header";
import {WORK_MODE_LABELS} from "./labels";


export const usePerson = (id: number | undefined): [(Person | undefined), React.Dispatch<React.SetStateAction<Person | undefined>>] => {
	const apiManager = useApiManager();
	const [getter, setter] = useState<Person | undefined>();
	const ctrl = apiManager.factory(PersonRestControllerApiFactory);

	useEffect(() => {
		if (id) {
			apiManager
			.execute(ctrl.getPerson(id))
			.then(c => setter(c));

		}
	}, [id]);
	return [getter, setter];
};

/**
 * Listado de personas (#13886): búsqueda, bajas con el conmutador «Eliminados» y exportaciones del
 * propio `AppList`; cada fila con su avatar, nombre y correo, unidad y nivel formativo.
 */
export const PersonListPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(PersonRestControllerApiFactory);


	const listConfig: AppListConfig<Person> = {
		title: "Personas",
		onClick: "/app/admin/employee/person",
		headers: [
			{title: "Persona", width: "34%"},
			{title: "Unidad"},
			{title: "Formación"},
			{title: "Modalidad"},
			{title: "Ayuda"},
		],
		decorator: (bean: Person) => {
			const name = personName(bean);
			return (
				<>
					<TableCell>
						<Stack direction="row" spacing={1.5} alignItems="center" sx={{minWidth: 0}}>
							<PersonAvatar name={name} size={32}/>
							<Box sx={{minWidth: 0}}>
								<Typography variant="body2" fontWeight={600} noWrap>{name}</Typography>
								<Typography variant="caption" color="text.secondary" noWrap display="block">{bean.email}</Typography>
							</Box>
							{bean.dismissed && <SoftChip tone="neutral" label="Baja"/>}
						</Stack>
					</TableCell>
					<TableCell>
						{bean.lastUnit?.name
							? <Typography variant="body2" noWrap>{bean.lastUnit.name}</Typography>
							: <Typography variant="body2" color="text.disabled">—</Typography>}
					</TableCell>
					<TableCell>
						<Typography variant="body2" noWrap color={bean.maxTrainingLevel?.label ? undefined : "text.disabled"}>
							{bean.maxTrainingLevel?.label || "—"}
						</Typography>
					</TableCell>
					<TableCell>
						{bean.workMode
							? <Typography variant="body2" noWrap>{WORK_MODE_LABELS[bean.workMode] || bean.workMode}</Typography>
							: <Typography variant="body2" color="text.disabled">—</Typography>}
					</TableCell>
					<TableCell>
						<Typography variant="body2" color="text.secondary" noWrap title={bean.help}>{bean.help}</Typography>
					</TableCell>
				</>
			);
		},
		supplier: async (currentPage, size, term, showDismissed) => {

			return ctrl.pagePerson(currentPage, size, undefined, term, showDismissed);
		},
		actions: [
			{
				action: () => {
					apiManager.executeRaw(ctrl.exportPeoplePerson()).then((resp) => {
						fileLocalSave(resp);
					});
				},
				label: "Exportar",
				icon: <FileDownloadRoundedIcon/>,
			},
			{

				action: () => {

					let year = new Date().getFullYear();
					year = parseInt(prompt("Indique el año", year.toString()) || year.toString());
					if (year) {
						if (confirm("El proceso puede tardar hasta unos minutos. ¿Desea continuar?")) {
							apiManager.executeRaw(ctrl.exportAbsencesPerson(year)).then((resp) => {
								fileLocalSave(resp);
							});
						}
					}
				},
				label: "Exportar ausencias",
				icon: <FileDownloadRoundedIcon/>,
			}
		]
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};
